import { createGlobalStyle } from 'styled-components';

export const GlobalTokens = createGlobalStyle`
  :root {
    --radius: 0.5rem;

    --background: oklch(0.984 0.003 140);
    --foreground: oklch(0.24 0.015 160);
    --card: oklch(1 0 0);
    --card-foreground: oklch(0.24 0.015 160);
    --muted: oklch(0.962 0.006 150);
    --muted-foreground: oklch(0.52 0.015 160);
    --secondary: oklch(0.955 0.008 150);
    --secondary-foreground: oklch(0.35 0.03 157);
    --border: oklch(0.912 0.006 150);
    --input: oklch(0.912 0.006 150);
    --ring: oklch(0.505 0.09 157);

    --primary: oklch(0.505 0.09 157);
    --primary-foreground: oklch(0.985 0.005 150);
    --primary-subtle: oklch(0.945 0.03 154);

    --success: oklch(0.55 0.11 155);
    --success-foreground: oklch(0.38 0.07 157);
    --success-subtle: oklch(0.945 0.035 152);
    --info: oklch(0.58 0.11 235);
    --info-foreground: oklch(0.42 0.09 240);
    --info-subtle: oklch(0.95 0.025 235);
    --warning: oklch(0.7 0.14 75);
    --warning-foreground: oklch(0.47 0.1 70);
    --warning-subtle: oklch(0.96 0.045 85);
    --teal: oklch(0.6 0.1 180);
    --teal-foreground: oklch(0.42 0.07 185);
    --teal-subtle: oklch(0.95 0.03 182);
    --destructive: oklch(0.577 0.215 27);
    --destructive-foreground: oklch(0.985 0.005 150);
    --destructive-subtle: oklch(0.955 0.02 27);
  }
`;

export const bp = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

export const alpha = (token, pct) =>
  `color-mix(in oklab, var(${token}) ${pct}%, transparent)`;
